import { Dialog } from '@reach/dialog'
import React from 'react'
import { useIntl } from 'react-intl'

import { DismissType } from '../../../shared/dialog/types'
import { SelectionView } from '../../profile/types'
import { ProjectsSelection } from '../../project/selection/ProjectsSelection'
import { ProjectVisibility } from '../../project/types'

type Props = {
  projectVisibility?: ProjectVisibility
  isOpen: boolean
  dismissType?: DismissType
  onConfirm: (value: string) => void
  onDismiss: (event?: React.SyntheticEvent<Element, Event> | undefined) => void
  defaultView: SelectionView
}

const SelectProjectDialog: React.FC<Props> = ({
  projectVisibility,
  dismissType = DismissType.close,
  onDismiss,
  isOpen,
  ...props
}) => {
  const intl = useIntl()

  return (
    <Dialog
      isOpen={isOpen}
      onDismiss={dismissType === DismissType.close ? onDismiss : undefined}
      aria-label={intl.formatMessage({
        id: 'timeTracking.select.project.title',
        defaultMessage: 'Select project',
      })}
      className="mx-auto bg-white md:my-20 md:w-full md:max-w-lg md:bg-transparent"
    >
      <ProjectsSelection
        projectVisibility={projectVisibility}
        dismissType={dismissType}
        onDismiss={onDismiss}
        {...props}
      />
    </Dialog>
  )
}

export { SelectProjectDialog }
